import {
  Flex,
  Badge,
  Center,
  Spinner,
  Alert,
  Button,
  FiExternalLink,
} from '@agrotoken-tech/ui';
import { PledgeDebtorDetail } from './PledgeDebtorDetail';
import { useTranslation } from '@bcba/react-hooks';
import { PLEDGE_SECTION_STATUSES_ICON } from '@bcba/frontend-utils';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { paths } from '../../../../routes/paths';
import { useCropPledgeContext } from '../context/CropPledgeContext';
import { CROP_PLEDGE_USER_ROLES } from '@bcba/types';
import { getCropPledgeDebtorInformation } from '../../../../services/crop-pledge/debtor-information/get-crop-pledge-debtor-information';
import { FormSection } from '../../shared';

export const DebtorSection = () => {
  const { t } = useTranslation();
  const { uuid = '' } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['get-crop-pledge-debtor-information', uuid],
    queryFn: () => getCropPledgeDebtorInformation(uuid),
  });

  const { cropPledgeSectionsStatusBadgeColors, role } = useCropPledgeContext();

  if (isLoading || !data) {
    return (
      <Center mt="8">
        <Spinner />
      </Center>
    );
  }

  const { status } = data;

  return (
    <Flex flexDir={'column'}>
      <FormSection
        title={t('cropPledgeDetail.asideNav.debtorData')}
        badge={
          <Badge
            icon={PLEDGE_SECTION_STATUSES_ICON[status]}
            colorScheme={cropPledgeSectionsStatusBadgeColors[status]}
            mr="2"
            iconPosition="leading"
          >
            {t(`cropPledge.section.status.${status}`)}
          </Badge>
        }
        action={
          role === CROP_PLEDGE_USER_ROLES.DEBTOR ? (
            <Button
              alignSelf={'flex-end'}
              display={'flex'}
              variant="linkSecondary"
              lineHeight={'20px'}
              onClick={() => navigate(paths.home)}
              sx={{
                span: {
                  h: '16px',
                  w: '16px',
                  svg: {
                    h: '16px',
                    w: '16px',
                  },
                },
              }}
              leftIcon={<FiExternalLink />}
              size={'sm'}
            >
              {t('cropPledge.linkToDigitalDossier')}
            </Button>
          ) : null
        }
      >
        {role === CROP_PLEDGE_USER_ROLES.DEBTOR && (
          <Alert
            title={t('cropPledge.alert.title')}
            description={t('cropPledge.alert.detail')}
            variant="gray"
          />
        )}
        <PledgeDebtorDetail data={data} refetch={refetch} />
      </FormSection>
    </Flex>
  );
};
